import * as React from 'react'
import { moment } from 'features/Moment'
import cn from 'classnames'
import { Table, TableHeader, TableRow } from 'features/Table'
import Pagination from 'components/Pagination'
import * as sLay from 'styles/modules/layout.scss'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import * as sMarg from 'styles/modules/margins.scss'
import { Field } from 'redux-form'
import DatePicker from 'components/Input/DatePicker'
import { transformDate } from 'features/Numbers/Numbers.actions'
import { joinAndCompact } from '../../utils/lodash'
import { useListCallsQuery, ListCallsQuery } from 'src/generated/graphql'

const TableContentInternet = ({ data }: { data: ListCallsQuery }) => (
  <Table
    header={
      <TableHeader>
        <div>Time</div>
        <div>Type</div>
        <div>Usage</div>
      </TableHeader>
    }
  >
    {data.calls.results.map((call, idx) => {
      const time = moment(call.dateTime).format('DD MMM YYYY, h:mm:ss a')
      return (
        <TableRow key={idx}>
          <div title={time}>{time}</div>
          <div>{call.usageType}</div>
          <div>{call.duration} GB</div>
        </TableRow>
      )
    })}
  </Table>
)

const TableContentPhoneLine = ({ data }: { data: ListCallsQuery }) => (
  <Table
    header={
      <TableHeader>
        <div>Time</div>
        <div>From</div>
        <div>Target</div>
        <div>Type</div>
        <div>Amount</div>
        <div>Duration</div>
      </TableHeader>
    }
  >
    {data.calls.results.map((call, idx) => {
      const time = moment(call.dateTime).format('DD MMM YYYY, h:mm:ss a')
      return (
        <TableRow key={idx}>
          <div title={time}>{time}</div>
          <div>{call.incomingCaller}</div>
          <div>{call.target}</div>
          <div>{call.usageType}</div>
          <div>{call.amountCharged}</div>
          <div>{call.duration} min</div>
        </TableRow>
      )
    })}
  </Table>
)

const TableContentCall = ({ data }: { data: ListCallsQuery }) => (
  <Table
    header={
      <TableHeader>
        <div>Time</div>
        <div>From</div>
        <div>Answer Point</div>
        <div className={sLay['hide-xs']}>Location</div>
        <div className={sLay['hide-xs']}>Status</div>
        <div>Duration</div>
      </TableHeader>
    }
  >
    {data.calls.results.map((call, idx) => {
      const time = moment(call.dateTime).format('DD MMM YYYY, h:mm:ss a')
      const location = joinAndCompact([call.location, call.state])
      return (
        <TableRow key={idx}>
          <div title={time}>{time}</div>
          <div>{call.incomingCaller}</div>
          <div>{call.answerPoint}</div>
          <div className={sLay['hide-xs']} title={location}>
            {location}
          </div>
          <div className={sLay['hide-xs']}>{call.callStatus}</div>
          <div>{call.duration} min</div>
        </TableRow>
      )
    })}
  </Table>
)

const NumberCalls = (props: any) => {
  const { location, replace, page, serviceId, formData } = props
  const isInternet = props.location.pathname.includes('internet')
  const isPhoneLine = props.location.pathname.includes('phone-lines')

  const { data, loading } = useListCallsQuery({
    variables: {
      serviceId,
      page,
      filterDate: transformDate(formData.dateFilter),
    },
  })

  const TableContent = isInternet
    ? TableContentInternet
    : isPhoneLine
    ? TableContentPhoneLine
    : TableContentCall

  return (
    <div>
      <div className={cn(sMarg.mb30, sLay['layout-row'], sLay['layout-align-end'])}>
        <Field label="Date" component={DatePicker} name="dateFilter" display="box" />
      </div>
      <div>
        {(loading || !data || data.calls.results.length === 0) && (
          <EmptyMessageCard
            loading={loading}
            title="You have no usage history yet."
            subtitle="This will appear when you start using your service."
          />
        )}
        {!loading && data && data.calls && data.calls.results.length > 0 && (
          <TableContent data={data} />
        )}
        {!loading && data && data.calls && (
          <Pagination
            page={page}
            numPages={data.calls.totalPages}
            onClick={page => {
              replace({
                pathname: location.pathname,
                query: {
                  page,
                },
              })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default NumberCalls



// WEBPACK FOOTER //
// src/pages/NumberCalls/NumberCalls.tsx